import type {
  AnaliseCritica,
  CriteriosPropostaJulgamento,
  PrazosImportantes,
} from 'store/modules/bidding_summary_store/types';

export const NAO_INFORMADO = 'Não informado';

export const DEFAULT_SUMMARY_FIELD_EMPTY =
  ' Não foi encontrada essa informação no documento fornecido. Recomendamos revisar o documento.';

export const PRAZOS_IMPORTANTES_LABELS: Record<keyof PrazosImportantes, string> = {
  tipo_fornecimento: 'Tipo de fornecimento',
  prazo_envio_doc_complementar: 'Prazo para envio de documentação complementar',
  prazo_envio_doc_original: 'Prazo para envio de documento original',
  prazo_contratual_ou_arp: 'Prazo contratual ou ARP',
  limite_envio_propostas: 'Limite para envio de propostas',
  prazo_manifestacao_recurso: 'Prazo para manifestação de recurso',
  prazo_recursos_contrarrazoes: 'Prazo para recursos e contrarrazões',
  prazo_esclarecimentos: 'Esclarecimentos',
  limite_impugnacao: 'Limite para impugnação',
  prazo_vigencia_contrato_ata: 'Prazo de vigência do contrato ou ata',
};

export const CRITERIOS_PROPOSTA_LABELS: Record<keyof CriteriosPropostaJulgamento, string> = {
  validade_proposta: 'Validade da proposta',
  exigencias_proposta_comercial: 'Exigências da proposta comercial',
  criterios_desempate: 'Critérios de desempate',
};

export const ANALISE_CRITICA_LABELS: Record<keyof AnaliseCritica, string> = {
  conflito_objeto_minuta: 'Conflito objeto / minuta',
  conflito_prazo_vigencia_arp: 'Conflito prazo de vigência / ARP',
  conflito_prazos_entrega: 'Conflito prazos de entrega',
  permite_subcontratacao: 'Permite subcontratação',
  previsao_reajuste_repactuacao: 'Previsão de reajuste / repactuação',
  permite_renovacao_contrato: 'Permite renovação de contrato',
  estabelece_condicoes_pagamento: 'Estabelece condições de pagamento',
};

export const BIDDING_SUMMARY_ACCORDION_KEYS = [
  'identificacao',
  'sessao',
  'orgao',
  'detalhesLicitacao',
  'seguroGarantia',
  'entregaExecucao',
  'prazosImportantes',
  'criteriosProposta',
  'resumoItens',
  'documentosHabilitacao',
  'atestado',
  'legislacao',
  'anexos',
  'outrasInformacoes',
  'condicoesPagamento',
  'exigenciasEspecificas',
  'penalidades',
  'questionamentos',
  'analiseCritica',
  'consideracoesLicitante',
] as const;

export type AccordionKey = (typeof BIDDING_SUMMARY_ACCORDION_KEYS)[number];

export const INITIAL_ACCORDION_OPEN: Record<AccordionKey, boolean> =
  BIDDING_SUMMARY_ACCORDION_KEYS.reduce(
    (acc, key) => {
      acc[key] = true;
      return acc;
    },
    {} as Record<AccordionKey, boolean>,
  );

export const biddingSummaryPanelId = (key: AccordionKey): string =>
  `bidding-summary-panel-${key.replace(/([A-Z])/g, '-$1').replace(/^-/, '').toLowerCase()}`;
